/* eslint-disable no-undef */

import md5 from 'md5';
import { palSdkSource } from '#/config/constants';
import { hasAdvertisingConsent } from '#/services/consent/consent';

const isClient = typeof window !== 'undefined';
let pNonceLoader;

// Load Google PAL SDK scripts
const loadPalSdk = async () => {
  if (!isClient) {
    throw new Error('PAL sdk is only available in the browser');
  }

  await new Promise((resolve, reject) => {
    const palScript = document.createElement('script');
    palScript.src = palSdkSource;
    palScript.onload = () => {
      resolve();
    };
    palScript.onerror = () => {
      reject();
    };
    document.head.appendChild(palScript);
  });

  const consentSettings = new goog.pal.ConsentSettings();
  consentSettings.allowStorage = hasAdvertisingConsent();
  return new goog.pal.NonceLoader(consentSettings);
};

const getNonceLoader = () => {
  if (!hasAdvertisingConsent()) {
    return Promise.resolve(null);
  }

  if (!pNonceLoader) {
    pNonceLoader = loadPalSdk().catch(e => {
      pNonceLoader = null;

      if (isClient) {
        throw e;
      }

      return null;
    });
  }

  return pNonceLoader;
};

const generateNonce = async ppid => {
  const nonceLoader = await getNonceLoader();

  if (!nonceLoader) {
    return null;
  }

  const request = new goog.pal.NonceRequest();
  request.adWillAutoPlay = true;
  request.adWillPlayMuted = true;
  request.continuousPlayback = false;
  request.descriptionUrl = 'https://sensical.com';
  request.iconsSupported = true;
  request.playerType = 'videojs';
  request.playerVersion = '7.11.4';
  request.ppid = ppid;
  request.videoHeight = 480;
  request.videoWidth = 640;

  const manager = await nonceLoader.loadNonceManager(request);
  return manager.getNonce();
};

const getAdvertisingIdentifiers = async userId => {
  if (!hasAdvertisingConsent()) {
    return {};
  }

  const ppid = md5(userId);
  const pall = await generateNonce(ppid).catch(() => null);

  return {
    ppid,
    ...(pall && { pall }),
    rdid: md5(navigator.userAgent),
  };
};

// Manage ad parameters
export const buildAdTagParameters = async (userId, ageRange) => {
  const age = ageRange;
  const idtype = 'msai';
  const advertisingIdentifiers = await getAdvertisingIdentifiers(userId);

  const adTagVariables = {
    age,
    ...advertisingIdentifiers,
    is_lat: hasAdvertisingConsent() ? '0' : '1',
    idtype,
  };
  return new URLSearchParams(adTagVariables).toString();
};
